import React from 'react';
import './css/font.css';
import './css/Register.css';
import {
    Navigate,
    Route,
    Routes
} from "react-router-dom";
import Register from "./Register";
import Login from "./Login";
import Profile from "./Profile";
import Evo3 from "./Evo3";
import Evo4 from "./Evo4";
import EditProfile from "./EditProfile";
import EditPass from "./EditPass";
import Stage from "./Stage";
import PerformanceMachines from "./PerformanceMachines";
import ListedMachines from "./ListedMachines";
import LicensedMachines from "./LicensedMachines";
import ListedMachinePrefs from "./ListedMachinePrefs";
import InstallInstructions from "./InstallInstructions";
import LicenseTiers from "./LicenseTiers";
import ResetPass from "./ResetPass";
export default function Navigation() {
  return (
      <Routes>
          <Route path="/"  element={<Navigate to="/evo4" replace />} />
          <Route path="/login"  element={<Login/>} />
          <Route path="/register"  element={<Register/>} />
          <Route path="/profile"  element={<Profile/>} />
          <Route path="/edit"  element={<EditProfile/>} />
          <Route path="/pass"  element={<EditPass/>} />
          <Route path="/resetPass"  element={<ResetPass/>} />
          <Route path="/evo3"  element={<Navigate to="/evo4" replace />} />
          <Route path="/evo4"  element={<Evo4/>} />
          <Route path="/stage"  element={<Stage/>} />
          <Route path="/listing"  element={<ListedMachines/>} />
          <Route path="/license"  element={<LicensedMachines/>} />
          <Route path="/events"  element={<ListedMachinePrefs/>} />
          <Route path="/perfmacs"  element={<PerformanceMachines/>} />
          <Route path="/install"  element={<InstallInstructions/>} />
          <Route path="/licensetiers"  element={<LicenseTiers/>} />
      </Routes>
  );
}
